// @flow
import * as React from 'react';
import { Modal } from 'react-bootstrap';

type Props = {
  show?: boolean,
  onHide: () => void
};

const AgencyRequestModal = ({ show, onHide }: Props) => (
  <Modal show={show} onHide={onHide}>
    <Modal.Header closeButton>
      <Modal.Title>Agency Request</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <p>
        The request for agency needs to be approved. You will be notified of the
        result.
      </p>
    </Modal.Body>
  </Modal>
);

export default AgencyRequestModal;



// WEBPACK FOOTER //
// ./src/components/AgencyRequestModal.js